<template>
  <div>
    <v-form @submit.prevent="submit">
      {{ identityNo }}
      <v-select
        v-if="$store.getters['user/isAdmin']"
        v-model="form.companyId"
        :items="companyItems"
        label="회사"
      ></v-select>

      <v-autocomplete
        v-model="form.tags"
        :items="tagItems"
        label="태그"
        multiple
      ></v-autocomplete>

      <v-btn type="submit" color="primary">편집</v-btn>
    </v-form>
  </div>
</template>

<script>
import { getDevice, getCompanies, getTags, editDevice } from '@/api'

export default {
  data () {
    return {
      id: null,
      identityNo: 0,
      form: {
        companyId: null,
        tags: []
      },
      companies: [],
      loadingCompanies: false,
      tags: [],
      loadingTags: false
    }
  },
  created () {
    if (this.$store.getters['user/isAdmin']) this.fetchCompanies()
    this.fetchTags()
  },
  computed: {
    companyItems () {
      return this.companies.map(company => {
        return {
          value: company.id,
          text: company.name
        }
      })
    },
    tagItems () {
      return this.tags.map(tag => {
        return {
          value: tag.id,
          text: tag.value
        }
      })
    }
  },
  async beforeRouteEnter (to, from, next) {
    const id = to.params.id

    try {
      const device = await getDevice(id)

      next(vm => {
        if (device) {
          vm.id = device.id
          vm.identityNo = device.identityNo
          vm.form.companyId = device.companyId
          vm.form.tags = device.tags.map(tag => tag.id)
        }
      })
    } catch (err) {
      console.error(err.message)
      next()
    }
  },
  methods: {
    async fetchCompanies () {
      this.loadingCompanies = true

      try {
        const { items: companies } = await getCompanies()

        this.companies = companies
      } catch (err) {
        console.error(err)
      } finally {
        this.loadingCompanies = false
      }
    },
    async fetchTags () {
      this.loadingTags = true

      try {
        const { items: tags } = await getTags()

        this.tags = tags
      } catch (err) {
        console.error(err)
      } finally {
        this.loadingTags = false
      }
    },
    async submit () {
      try {
        await editDevice(this.id, this.form)
        this.$router.go(-1)
      } catch (err) {
        alert(err.message)
      }
    }
  }
}
</script>
